import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AfricaTalkingService } from './api/africaTalking.service';
import { BroadcastMessageService } from './api/broadcastMessage.service';
import { DashboardService } from './api/dashboard.service';
import { DistributionReportService } from './api/distributionReport.service';
import { FeedbackService } from './api/feedback.service';
import { MapContentToServiceService } from './api/mapContentToService.service';
import { NitroSwitchService } from './api/nitroSwitch.service';
import { PartnerService } from './api/partner.service';
import { RelayService } from './api/relay.service';
import { SenderIdRequestService } from './api/senderIdRequest.service';
import { ServicePlansService } from './api/servicePlans.service';
import { ServiceSubscriptionContentsService } from './api/serviceSubscriptionContents.service';
import { SmsClientService } from './api/smsClient.service';
import { SmsRouteService } from './api/smsRoute.service';
import { SmsServiceSubscriptionService } from './api/smsServiceSubscription.service';
import { SmtpSettingsService } from './api/smtpSettings.service';
import { SubActivationPerPlanserviceService } from './api/subActivationPerPlanservice.service';
import { SubscribersService } from './api/subscribers.service';
import { TransactionLogService } from './api/transactionLog.service';
import { ValuesService } from './api/values.service';
import { VasServiceService } from './api/vasService.service';
import { WebServiceSubscriptionService } from './api/webServiceSubscription.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AfricaTalkingService,
    BroadcastMessageService,
    DashboardService,
    DistributionReportService,
    FeedbackService,
    MapContentToServiceService,
    NitroSwitchService,
    PartnerService,
    RelayService,
    SenderIdRequestService,
    ServicePlansService,
    ServiceSubscriptionContentsService,
    SmsClientService,
    SmsRouteService,
    SmsServiceSubscriptionService,
    SmtpSettingsService,
    SubActivationPerPlanserviceService,
    SubscribersService,
    TransactionLogService,
    ValuesService,
    VasServiceService,
    WebServiceSubscriptionService ]
})
export class ApiModule {
  public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
